import { Capacitor } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar'

function themeColors() {
  const dark = window.matchMedia('(prefers-color-scheme: dark)').matches
  return {
    background: dark ? '#1f1f1f' : '#ffffff',
    // Capacitor 4: Dark = texto claro (fondos oscuros); Light = texto oscuro.
    style: dark ? Style.Dark : Style.Light,
  }
}

async function applyStatusBarTheme() {
  const { background, style } = themeColors()
  await StatusBar.setBackgroundColor({ color: background })
  await StatusBar.setStyle({ style })
}

function forceNoSafeAreaTop(): void {
  document.documentElement.classList.add('galidancia-native-android')
  // Inline: Ionic u otros scripts no deben reintroducir safe-area en el header.
  document.documentElement.style.setProperty('--ion-safe-area-top', '0px')
}

/** Marca el DOM cuanto antes para que el CSS no hinche el header con safe-area. */
export function markNativeAndroidDom(): void {
  if (Capacitor.getPlatform() === 'android') {
    forceNoSafeAreaTop()
  }
}

/**
 * En la app Android el WebView no debe pintarse debajo de la barra de estado
 * (MainActivity + StatusBar). Marcamos el DOM para que el CSS NO hinche el
 * ion-header con safe-area otra vez: el hueco debe ir en ion-tabs (contenido).
 */
export async function configureNativeStatusBar(): Promise<void> {
  if (Capacitor.getPlatform() !== 'android') {
    return
  }
  try {
    forceNoSafeAreaTop()
    await StatusBar.setOverlaysWebView({ overlay: false })
    await applyStatusBarTheme()

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      void applyStatusBarTheme()
    })

    const { App } = await import('@capacitor/app')
    await App.addListener('appStateChange', ({ isActive }) => {
      if (!isActive) return
      forceNoSafeAreaTop()
      void StatusBar.setOverlaysWebView({ overlay: false }).catch(() => undefined)
      void applyStatusBarTheme()
    })
  } catch {
    // Web o plugin no disponible en este runtime.
  }
}
